import React, { Component, ErrorInfo } from 'react';

import { fireDialog } from '../dialog/dialog.service';
import { intl } from '../i18n/i18n.config';
import errorLogger from './helpers/error-logger.helper';

interface IErrorBoundaryProps {}

interface IErrorBoundaryState {
	error: string | null;
}

class ErrorBoundary extends Component<
	IErrorBoundaryProps,
	IErrorBoundaryState
> {
	constructor(props: IErrorBoundaryProps) {
		super(props);

		this.state = { error: null };
	}

	static getDerivedStateFromError(error: Error) {
		return { error: error.message };
	}

	componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		errorLogger({
			name: error.name || 'ReactError',
			message: error.message,
			extra: { componentStack: errorInfo.componentStack },
		});
	}

	render() {
		if (this.state.error) {
			fireDialog({
				title: intl.formatMessage({ id: 'errors.exception.title' }),
				text: this.state.error,
				allowOutsideClick: false,
				allowEnterKey: false,
				allowEscapeKey: false,
				showConfirmButton: false,
			});

			return <></>;
		}

		return <>{this.props.children}</>;
	}
}

export default ErrorBoundary;
